<template>
	<div class='slate-bg'>
		<transition name="fade">
			<div v-if="loading" id="preloader">
				<div id="status"></div>
			</div>
		</transition>
		<header>
      <nav class="container">
			<div class="row">
				<div class="col-xs-12">
					<img class="img-responsive logo-head" src="@/assets/images/eas-head.svg" alt="EAS Strategies">
				</div>
			</div>
				<div class="login-title-padding">
				<div class="row">
					<div class="col-xs-12 col-sm-8 col-md-6">
						<div class="login-page-title">Welcome to the EAS projects database</div>
					</div>
					<div class="col-xs-12 col-sm-8 col-md-5 col-md-offset-1">
						<div class="">
						<div class="form-group">
							<label for="email" class="form-label sr-only">Email</label>
							<input
								v-model="email_address"
								class="form-control"
								name="email"
								type="email"
								placeholder="Email"
								required
								@keyup.enter="login"
							>
						</div>
						<div class="form-group">
							<label class="form-label sr-only" for="inputPassword">Password</label>
							<input
								v-model="password"
								class="form-control"
								name="password"
								type="password"
								placeholder="Password"
								required
								@keyup.enter="login"
							>
						</div>
						<div class="left-center-xs">
							<button class="btn btn-md btn-success" type="submit" @click="login">Login</button>
							<div>
								<router-link class="btn btn-clear" to="/forgot-password" type="button">
									Forgotten your password?
								</router-link>
							</div>
						</div>
						</div>
					</div>
				</div>
			</div>
      </nav>
		<div class="container">
			<div class="row">
			</div>
		</div>
		</header>

		<section class="pre-footer-bg">
		</section>

			<footer>
		<div class="container">
			<div class="row">
				<div class="col-xs-12 logo-container-foot">
					<a href="index.html">
					<img class="img-responsive logo-foot" src="@/assets/images/eas-head.svg" alt="EAS Strategies">
					</a>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 text-center">
					<p>
						<a href="https://eas-strategies.com/" target="_blank">EAS Strategies</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/privacy/" target="_blank">Privacy policy</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/disclaimer/" target="_blank">Disclaimer</a>
						<br />
						<br />
						©  {{currentYear}} EAS Strategies Ltd.
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="http://www.bubblegate.co.uk" target="_blank">Built by Bubblegate</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
	</div>
</template>

<style lang="less">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import moment from 'moment';
import { Notification } from 'uiv';

export default {
	created() {
		this.runLoader();
	},
	data() {
		return {
			email_address: null,
			password: null,
			loading: false
		};
	},
	methods: {
		async login() {
			try {
				await this.$store.dispatch('login', {
					email_address: this.email_address, password: this.password
				});
				this.$router.push({ path: '/' });
			} catch (e) {
				Notification.notify({
					type: 'warning',
					title: 'Could not login',
					content: e.response ? e.response.data.message : 'Invalid email/password',
					duration: 3000
				});
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		}
	},
	computed: {
		currentYear() {
			return moment().format('YYYY');
		}
	}
};
</script>
